(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-footer"] && !window.DesignMode) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero-afiliate"]) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero-app"]) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero-book"]) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero-business-loans"]) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero-calendly"]) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero-credit-enhacement"]) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero-event"] && !window.DesignMode) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero-events"]) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero-infinitebanking"]) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero-insuranceagent"]) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero-membership"]) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero-privatecalendar"]) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero-referal"]) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero-sponsorship"]) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero-taxStrategies"]) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero-thebestretirementplan"]) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero-utility"]) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero-vacations"]) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero-wealthpackages"]) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-hero"] && !window.DesignMode) return;
  try {
    

window.reproducir = function() {
   $('.button-play-hero').addClass('ocultar');
      $("#video").attr("controls", "");
    document.getElementById("video").play();
};

window.pausar = function() {
    document.getElementById("video").pause();
};
let myVideo = document.getElementById("video");
window.togglePlay = function() {
if (!myVideo.paused) {

    myVideo.pause();
}else{

   myVideo.play();
}


};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-plans-infinitebanking"]) return;
  try {
    
 var tabs = function(id) {
  this.el = document.getElementById(id);
  
  this.tab = {
    el: '.tab',
    list: null
  }
  
  this.nav = {
    el: '.tab-nav',
    list: null
  }
  
  this.pag = {
    el: '.tab-pag',
    list: null
  }
  
  this.count = null;
  this.selected = 0;
  
  this.init = function() {
    // Create tabs
    this.tab.list = this.createTabList();
    this.count = this.tab.list.length;
    
    // Create nav
    this.nav.list = this.createNavList();
    this.renderNavList();
    
    // Create pag
    this.pag.list = this.createPagList();
    this.renderPagList();
    
    // Set selected
    this.setSelected(this.selected);
  }
  
  this.createTabList = function() {
    var list = [];
    
    this.el.querySelectorAll(this.tab.el).forEach(function(el, i) {
      list[i] = el;
    });
    
    return list;
  }
  
  this.createNavList = function() {
    var list = [];
    
    this.tab.list.forEach(function(el, i) {
      var listitem = document.createElement('a');
          listitem.className = 'nav-item',
          listitem.innerHTML = el.getAttribute('data-name'),
          listitem.onclick = function() {
            this.setSelected(i);
            return false;
          }.bind(this);
      
      list[i] = listitem;
    }.bind(this));
    
    return list;
  }
  
  this.createPagList = function() {
    var list = [];
    
    list.prev = document.createElement('a');
    list.prev.className = 'pag-item pag-item-prev',
      list.prev.innerHTML = 'Prev',
      list.prev.onclick = function() {
      this.setSelected(this.selected - 1);
      return false;
    }.bind(this);

    list.next = document.createElement('a');
    list.next.className = 'pag-item pag-item-next',
      list.next.innerHTML = 'Next',
      list.next.onclick = function() {
      this.setSelected(this.selected + 1);
      return false;
    }.bind(this);
    
    list.submit = document.createElement('button');
    list.submit.className = 'pag-item pag-item-submit',
    list.submit.innerHTML = 'Submit';
    
    return list;
  }
  
  this.renderNavList = function() {
    var nav = document.querySelector(this.nav.el);
    
    this.nav.list.forEach(function(el) {
      nav.appendChild(el);
    });
  }
  
  this.renderPagList = function() {
    var pag = document.querySelector(this.pag.el);
    
    pag.appendChild(this.pag.list.prev);
    pag.appendChild(this.pag.list.next);
    pag.appendChild(this.pag.list.submit);
  }
  
  this.setSelected = function(target) {
    var min = 0,
        max = this.count - 1;
    
    if(target > max || target < min) {
      return;
    }
    
    if(target == min) {
      this.pag.list.prev.classList.add('hidden');
    } else {
      this.pag.list.prev.classList.remove('hidden');
    }
    
    if(target == max) {
      this.pag.list.next.classList.add('hidden');
      this.pag.list.submit.classList.remove('hidden');
    } else {
      this.pag.list.next.classList.remove('hidden');
      this.pag.list.submit.classList.add('hidden');
    }
    
    this.tab.list[this.selected].classList.remove('selected');
    this.nav.list[this.selected].classList.remove('selected');

    this.selected = target;
    this.tab.list[this.selected].classList.add('selected');
    this.nav.list[this.selected].classList.add('selected');
  }
};

var tabbedForm = new tabs('tabbedForm');
tabbedForm.init();

 

$(function(){
  $('#tabbedForm a').attr('href','');
});



 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-plans-sponsorship"]) return;
  try {
    
/*  $('#ContactForm .button-2').on('click', function(e){
        e.preventDefault();
    
    });*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-plans-taxStrategies"]) return;
  try {
    
/*  $('#ContactForm .button-2').on('click', function(e){
        e.preventDefault();
    
    });*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-plans-thebestretirementplans"]) return;
  try {
    
 var tabs = function(id) {
  this.el = document.getElementById(id);
  
  this.tab = {
    el: '.tab',
    list: null
  }
  
  this.nav = {
    el: '.tab-nav',
    list: null
  }
  
  this.pag = {
    el: '.tab-pag',
    list: null
  }
  
  this.count = null;
  this.selected = 0;
  
  this.init = function() {
    // Create tabs
    this.tab.list = this.createTabList();
    this.count = this.tab.list.length;
    
    // Create nav
    this.nav.list = this.createNavList();
    this.renderNavList();
    
    // Create pag
    this.pag.list = this.createPagList();
    this.renderPagList();
    
    // Set selected
    this.setSelected(this.selected);
  }
  
  this.createTabList = function() {
    var list = [];
    
    this.el.querySelectorAll(this.tab.el).forEach(function(el, i) {
      list[i] = el;
    });
    
    return list;
  }
  
  this.createNavList = function() {
    var list = [];
    
    this.tab.list.forEach(function(el, i) {
      var listitem = document.createElement('a');
          listitem.className = 'nav-item',
          listitem.innerHTML = el.getAttribute('data-name'),
          listitem.onclick = function() {
            this.setSelected(i);
            return false;
          }.bind(this);
      
      list[i] = listitem;
    }.bind(this));
    
    return list;
  }
  
  this.createPagList = function() {
    var list = [];
    
    list.prev = document.createElement('a');
    list.prev.className = 'pag-item pag-item-prev',
      list.prev.innerHTML = 'Prev',
      list.prev.onclick = function() {
      this.setSelected(this.selected - 1);
      return false;
    }.bind(this);

    list.next = document.createElement('a');
    list.next.className = 'pag-item pag-item-next',
      list.next.innerHTML = 'Next',
      list.next.onclick = function() {
      this.setSelected(this.selected + 1);
      return false;
    }.bind(this);
    
    list.submit = document.createElement('button');
    list.submit.className = 'pag-item pag-item-submit',
    list.submit.innerHTML = 'Submit';
    
    return list;
  }
  
  this.renderNavList = function() {
    var nav = document.querySelector(this.nav.el);
    
    this.nav.list.forEach(function(el) {
      nav.appendChild(el);
    });
  }
  
  this.renderPagList = function() {
    var pag = document.querySelector(this.pag.el);
    
    pag.appendChild(this.pag.list.prev);
    pag.appendChild(this.pag.list.next);
    pag.appendChild(this.pag.list.submit);
  }
  
  this.setSelected = function(target) {
    var min = 0,
        max = this.count - 1;
    
    if(target > max || target < min) {
      return;
    }
    
    if(target == min) {
      this.pag.list.prev.classList.add('hidden');
    } else {
      this.pag.list.prev.classList.remove('hidden');
    }
    
    if(target == max) {
      this.pag.list.next.classList.add('hidden');
      this.pag.list.submit.classList.remove('hidden');
    } else {
      this.pag.list.next.classList.remove('hidden');
      this.pag.list.submit.classList.add('hidden');
    }
    
    this.tab.list[this.selected].classList.remove('selected');
    this.nav.list[this.selected].classList.remove('selected');

    this.selected = target;
    this.tab.list[this.selected].classList.add('selected');
    this.nav.list[this.selected].classList.add('selected');
  }
};

var tabbedForm = new tabs('tabbedForm');
tabbedForm.init();

 

$(function(){
  $('#tabbedForm a').attr('href','');
});



 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-plans-wealthpackages"]) return;
  try {
    
 window.addEventListener('DOMContentLoaded', function () {
    $(function () {

      $('.modal').appendTo('body');

      $('.modal').on('hide.bs.modal', function (event) {
        $('#shopify-section-announcement-bar').css("opacity", "1");

      });

      $('.modal').on('show.bs.modal', function (event) {
        $('#shopify-section-announcement-bar').css("opacity", "0");

      });

    })
  })
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
